//GeneratorFlag:[NoChange]
import Activity from './activity';

export default {Activity}
export{Activity}